
import { createRoot } from 'react-dom/client';
import React from 'react';
import App from './App.tsx';
import './index.css';
import { initializeSentry } from './utils/sentry';

// Enhanced error handling for the main entry point
const initializeApp = () => {
  try {
    console.log('[Main] Starting Flamingo app...');
    
    // Initialize Sentry AFTER React is about to render
    initializeSentry();
    
    const container = document.getElementById("root");
    
    if (!container) {
      throw new Error('Root container not found');
    }

    const root = createRoot(container);
    // Properly wrap App in React.StrictMode for hooks support
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    console.log('[Main] App mounted successfully');
  } catch (error) {
    console.error('[Main] Failed to initialize app:', error);
    
    // Secure fallback error display using DOM manipulation (no innerHTML)
    const container = document.getElementById("root") || document.body;
    
    // Clear container safely
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
    
    // Create error UI using DOM API
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'min-height: 100vh; background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%); display: flex; align-items: center; justify-content: center; color: white; font-family: Inter, system-ui, -apple-system, sans-serif; text-align: center; padding: 20px;';
    
    const contentDiv = document.createElement('div');
    
    const logo = document.createElement('img');
    logo.src = '/lovable-uploads/76503acc-0290-4b3e-ae3b-f6ab214ab2ce.png';
    logo.alt = 'Flamingo';
    logo.style.cssText = 'height: 40px; margin: 0 auto 24px; display: block;';
    
    const title = document.createElement('h1');
    title.textContent = 'Connection Issue';
    title.style.cssText = 'font-size: 24px; margin-bottom: 16px; font-weight: 600;';
    
    const message = document.createElement('p');
    message.textContent = 'The app failed to load properly. This usually resolves with a refresh.';
    message.style.cssText = 'margin-bottom: 24px; opacity: 0.8; max-width: 400px;';
    
    const button = document.createElement('button');
    button.textContent = 'Refresh App';
    button.style.cssText = 'background: linear-gradient(135deg, #ec4899 0%, #f472b6 100%); color: white; border: none; padding: 12px 24px; border-radius: 8px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s;';
    button.onclick = () => window.location.reload();
    button.onmouseover = () => button.style.transform = 'scale(1.05)';
    button.onmouseout = () => button.style.transform = 'scale(1)';
    
    contentDiv.appendChild(logo);
    contentDiv.appendChild(title);
    contentDiv.appendChild(message);
    contentDiv.appendChild(button);
    errorDiv.appendChild(contentDiv);
    container.appendChild(errorDiv);
  }
};

// Initialize app when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}
